
export default {
  props: {
    items: {
      type: Array,
      default: () => [
        {
          principal: "Création graphique et rédaction des contenus",
          description: "Pour un site web à la hauteur de tes ambitions",
        },
        {
          principal: "Optimisation pour les moteurs de recherche",
          description:
            "Le choix des bons mots-clés pour booster ta visibilité sur Google",
        },
        {
          principal: "Version mobile et tablette",
          description: "Accessible partout et à toute heure",
        },
        {
          principal: "Réservation de ton nom de domaine",
          description: "Impose ton identité avec un www qui fait rêver",
        },
        {
          principal:
            "Hébergement, maintenance et sécurisation sur nos serveurs",
          description: "La facilité et la sécurité en un tour de main",
        },
      ],
    },
    textColor: {
      type: String,
      default: "text-purple-brand",
    },
    textSize: {
      type: String,
      default: "",
    },
    gap: {
      type: String,
      default: "mb-8",
    },
    bulletIcon: {
      type: String,
      default: "list-check",
    },
  },
};
